import { RemoteHandleReportsAnalyticalActivitiesByStudent } from 'data/usecases';
import { HandleReportsAnalyticalActivitiesByStudent } from 'domain/usecases';
import { makeApiUrlReportsAnalyticalActivitiesByStudent } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleReportsAnalyticalActiviesStudents =
  (): HandleReportsAnalyticalActivitiesByStudent =>
    new RemoteHandleReportsAnalyticalActivitiesByStudent(
      makeApiUrlReportsAnalyticalActivitiesByStudent(),
      makeAxiosHttpClient(),
    );
